import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import {messages as en} from './messages/en.js' ;
Vue.use(BootstrapVue);
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'en', // set locale
    messages: {
        en: en
    }
});

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')